export default [
  {
    path: '/activities/',
    component: () => {
      return import(
        /* webpackChunkName: "activities" */ '@/views/activities/index.vue'
      )
    },
    children: [
      {
        path: 'aon',
        name: 'aon',
        component: () => {
          return import(
            /* webpackChunkName: "activities" */ '@/views/activities/short-term/aon/regist.vue'
          )
        }
      },
      {
        path: 'aon/result',
        name: 'aonResult',
        component: () => {
          return import(
            /* webpackChunkName: "activities" */ '@/views/activities/short-term/aon/result.vue'
          )
        }
      },
      {
        path: 'aon/lucky',
        name: 'lucky',
        component: () => {
          return import(
            /* webpackChunkName: "activities" */ '@/views/activities/short-term/aon/lucky.vue'
          )
        }
      }
    ]
  }
]
